export const LoginHeader = () => {
	return (
		<div id="header">
			<div className="wrap">
				<div className="clearfix">
					<div className="fl">
						<div id="logo"><a className="no-text" href="http://www.reginamaria.ro/" title="Regina Maria">Regina Maria</a></div>
					</div>
					<div className="fr"></div>
				</div>
			</div>
		</div>
	);
}




